import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { LocalesResponse } from '@joc/api-gateway';
import { API } from 'core/API';
import {
	buildDirectLanguageKeyMap,
	buildIdToLanguageKeyMap,
	buildLocaleIdMap,
	LOCALES_QUERY_KEY,
	SupportedLanguageKey,
} from 'core/constants';

export const useLocales = () => {
	const query = useQuery<LocalesResponse[], unknown>({
		queryKey: [LOCALES_QUERY_KEY],
		queryFn: () => API.getAllLocales(),
		staleTime: Infinity,
	});

	const localeIdByKey = useMemo<Record<SupportedLanguageKey, number>>(
		() => buildLocaleIdMap(query.data),
		[query.data]
	);

	const languageKeyByLocaleId = useMemo<Record<number | string, SupportedLanguageKey>>(() => {
		const fromLocaleIdMap = buildIdToLanguageKeyMap(localeIdByKey);
		const fromLocales = buildDirectLanguageKeyMap(query.data);
		return {
			...fromLocaleIdMap,
			...fromLocales,
		};
	}, [localeIdByKey, query.data]);

	return {
		...query,
		locales: query.data || [],
		localeIdByKey,
		languageKeyByLocaleId,
	};
};
